<div class="not-found-container">
  <div class="not-found-content">
    <div class="error-code">404</div>
    <h1 class="error-title">Under Construction</h1>
    <p class="error-description">The page you're looking for is still being built or doesn't exist.</p>
    <button class="btn btn-primary" routerLink="/">Return to Main Site</button>
  </div>
  <div class="crane-container">
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 240 240">
      <defs>
        <style>
          .st0, .st1, .st2, .st3 {
            fill: none;
          }

          .st1, .st4, .st5, .st2, .st6, .st3, .st7 {
            stroke-linejoin: round;
          }

          .st1, .st4, .st5, .st6, .st3, .st7, .st8 {
            stroke: #231f20;
            stroke-width: 1.5px;
          }

          .st1, .st5 {
            stroke-linecap: round;
          }

          .st9, .st4 {
            fill: #231f20;
          }

          .st5, .st10, .st7, .st8 {
            fill: #fff;
          }

          .st2 {
            stroke:
            #f6d014;
            stroke-linecap: square;
            stroke-width: 6px;
          }

          .st6 {
            fill: #f6d014;
          }

          .st8 {
            stroke-miterlimit: 10;
          }

          .st11 {
            clip-path: url(#clippath);
          }

          .st12 {
            fill: #fbf1e3;
          }
        </style>
        <clipPath id="clippath">
          <polygon class="st0" points="385.23 170.65 329.23 170.65 332.23 159.67 382.23 159.67 385.23 170.65"/>
        </clipPath>
      </defs>

      <g id="Layer_11">
        <line class="st1" x1="1.85" y1="190" x2="200" y2="190"/>
        <g>
          <path class="st6" d="M181.31,168.61h0c-2.36,0-4.28,8.69-4.28,11.05v1.37c0,2.36,1.91,4.28,4.28,4.28h0c2.36,0,4.28-1.91,4.28-4.28v-1.37c0-2.36-1.91-11.05-4.28-11.05Z"/>
          <line class="st1" x1="181.31" y1="182.61" x2="181.31" y2="189.54"/>
        </g>

<!--Crane-->
        <g>
          <g>
            <g>
              <rect class="st3" x="37.89" y="159.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="159.89" x2="37.9" y2="169.89"/>
              <line class="st3" x1="47.9" y1="169.89" x2="37.9" y2="159.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="169.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="169.89" x2="37.9" y2="179.89"/>
              <line class="st3" x1="47.9" y1="179.89" x2="37.9" y2="169.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="179.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="179.89" x2="37.9" y2="189.89"/>
              <line class="st3" x1="47.9" y1="189.89" x2="37.9" y2="179.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="149.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="149.89" x2="37.9" y2="159.89"/>
              <line class="st3" x1="47.9" y1="159.89" x2="37.9" y2="149.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="139.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="139.89" x2="37.9" y2="149.89"/>
              <line class="st3" x1="47.9" y1="149.89" x2="37.9" y2="139.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="129.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="129.89" x2="37.9" y2="139.89"/>
              <line class="st3" x1="47.9" y1="139.89" x2="37.9" y2="129.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="119.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="119.89" x2="37.9" y2="129.89"/>
              <line class="st3" x1="47.9" y1="129.89" x2="37.9" y2="119.89"/>
            </g>
            <g>
              <rect class="st3" x="37.89" y="109.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="109.89" x2="37.9" y2="119.89"/>
              <line class="st3" x1="47.9" y1="119.89" x2="37.9" y2="109.89"/>
            </g>
            <g>
              <rect class="st7" x="37.89" y="99.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="99.89" x2="37.9" y2="109.89"/>
              <line class="st3" x1="47.9" y1="109.89" x2="37.9" y2="99.89"/>
            </g>
            <g>
              <rect class="st7" x="37.89" y="89.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="89.89" x2="37.9" y2="99.89"/>
              <line class="st3" x1="47.9" y1="99.89" x2="37.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="37.89" y="79.89" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="79.89" x2="37.9" y2="89.89"/>
              <line class="st3" x1="47.9" y1="89.89" x2="37.9" y2="79.89"/>
            </g>
            <polygon class="st7" points="42.9 59.91 47.9 79.89 37.9 79.89 42.9 59.91"/>
          </g>
          <g>
            <g>
              <polygon class="st7" points="97.9 89.89 87.9 79.89 87.9 89.89 97.9 89.89"/>
              <line class="st3" x1="87.9" y1="79.89" x2="97.9" y2="89.89"/>
              <line class="st3" x1="92.9" y1="84.89" x2="87.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="77.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="77.9" y1="79.89" x2="87.9" y2="89.89"/>
              <line class="st3" x1="87.9" y1="79.89" x2="77.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="67.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="67.9" y1="79.89" x2="77.9" y2="89.89"/>
              <line class="st3" x1="77.9" y1="79.89" x2="67.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="57.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="57.9" y1="79.89" x2="67.9" y2="89.89"/>
              <line class="st3" x1="67.9" y1="79.89" x2="57.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="47.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="47.9" y1="79.89" x2="57.9" y2="89.89"/>
              <line class="st3" x1="57.9" y1="79.89" x2="47.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="37.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="37.9" y1="79.89" x2="47.9" y2="89.89"/>
              <line class="st3" x1="47.9" y1="79.89" x2="37.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="27.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="27.9" y1="79.89" x2="37.9" y2="89.89"/>
              <line class="st3" x1="37.9" y1="79.89" x2="27.9" y2="89.89"/>
            </g>
            <g>
              <rect class="st7" x="17.9" y="79.9" width="10" height="10"/>
              <line class="st3" x1="17.9" y1="79.89" x2="27.9" y2="89.89"/>
              <line class="st3" x1="27.9" y1="79.89" x2="17.9" y2="89.89"/>
            </g>
          </g>
          <line class="st3" x1="117.9" y1="120.31" x2="117.9" y2="190"/>
          <line class="st3" x1="107.9" y1="120.31" x2="107.9" y2="190"/>
          <line class="st3" x1="97.9" y1="120.31" x2="97.9" y2="190"/>
          <line class="st3" x1="87.9" y1="120.31" x2="87.9" y2="190"/>
          <line class="st3" x1="77.9" y1="120.31" x2="77.9" y2="190"/>
          <line class="st3" x1="67.9" y1="120.31" x2="67.9" y2="190"/>
          <line class="st3" x1="117.9" y1="160" x2="67.9" y2="160"/>
          <rect class="st6" x="65.76" y="157.9" width="54.27" height="4.2"/>
          <rect class="st6" x="65.76" y="137.41" width="54.27" height="4.2"/>
          <line class="st3" x1="92.89" y1="89.9" x2="92.89" y2="107.95"/>
          <g class="crane">
            <rect class="st6" x="65.76" y="116.86" width="54.27" height="4.2"/>
            <polygon class="st7" points="92.9 107.95 108.78 116.87 77.02 116.87 92.9 107.95"/>
          </g>
        </g>
        <g>
        </g>
        <line class="st3" x1="42.9" y1="59.91" x2="77.9" y2="79.89"/>
        <line class="st3" x1="12.9" y1="79.89" x2="42.9" y2="59.91"/>
        <rect class="st9" x="32.89" y="89.89" width="20" height="5"/>
        <rect class="st4" x="7.89" y="79.89" width="10" height="10"/>
        <rect class="st9" x="32.89" y="185" width="20" height="5"/>
        <g>
          <polygon class="st7" points="106.72 110.16 169.76 99.63 169.76 190 106.72 190 106.72 110.16"/>
          <g>
            <rect class="st7" x="135.54" y="175.19" width="7.84" height="14.81"/>
            <line class="st1" x1="141.71" y1="181.97" x2="141.71" y2="182.01"/>
          </g>
          <g>
            <rect class="st7" x="143.47" y="175.19" width="7.84" height="14.81"/>
            <line class="st1" x1="145.14" y1="181.97" x2="145.14" y2="182.01"/>
          </g>
          <rect class="st7" x="157.92" y="175.19" width="7.84" height="7.84"/>
          <rect class="st7" x="110.56" y="175.19" width="7.84" height="7.84"/>
          <rect class="st7" x="122.39" y="175.19" width="7.84" height="7.84"/>
          <rect class="st7" x="146.08" y="152.81" width="7.84" height="13.37"/>
          <rect class="st7" x="157.92" y="152.81" width="7.84" height="13.37"/>
          <rect class="st7" x="110.56" y="152.81" width="7.84" height="13.37"/>
          <rect class="st7" x="122.39" y="152.81" width="7.84" height="13.37"/>
          <rect class="st7" x="134.23" y="152.81" width="7.84" height="13.37"/>
          <rect class="st7" x="146.08" y="134.21" width="7.84" height="13.37"/>
          <rect class="st7" x="157.92" y="134.21" width="7.84" height="13.37"/>
          <rect class="st7" x="110.56" y="134.21" width="7.84" height="13.37"/>
          <rect class="st7" x="122.39" y="134.21" width="7.84" height="13.37"/>
          <rect class="st7" x="134.23" y="134.21" width="7.84" height="13.37"/>
          <rect class="st7" x="146.08" y="115.62" width="7.84" height="13.37"/>
          <rect class="st7" x="157.92" y="115.62" width="7.84" height="13.37"/>
          <rect class="st7" x="110.56" y="115.62" width="7.84" height="13.37"/>
          <rect class="st7" x="122.39" y="115.62" width="7.84" height="13.37"/>
          <rect class="st7" x="134.23" y="115.62" width="7.84" height="13.37"/>
          <polygon class="st6" points="103.68 107.82 172.43 96.82 172.43 101.02 103.68 112.02 103.68 107.82"/>
        </g>

      </g>
    </svg>
  </div>
</div>
